import ToolBar from "../../../components/ToolBar";
import { Tab, Tabs } from "@mui/material";
import { handleUpdatePageSlice } from "../../../redux/slices/globalSlice";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useMemo, useState } from "react";
import IECActivities from "./IECActivities";
import { LoggedUserType } from "../../../models/GlobalModels";
import { loginSelector } from "../../../redux/slices/loginSlice";
import NoPermission from "../../../NoAccess/NoPermission";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div className="pt-3 tab-container">{children}</div>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const IEC = () => {
    const allTabOptions = [
        { label: 'IEC Activities', tabId: 0, permission: 'IEC-Module' },
    ];

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const user: LoggedUserType = useSelector(loginSelector).user;

    const authorizedTabs = useMemo(() => {
        return allTabOptions
            .filter(tab => user?.permissions?.includes(tab.permission))
            .map((tab, index) => ({
                ...tab,
                displayIndex: index
            }));
    }, [user?.permissions]);
    
    const [value, setValue] = useState<number>(() => {
        const savedValue = localStorage.getItem("selectedICVTab");
        if (savedValue !== null) {
            const savedTabId = parseInt(savedValue, 10);
            // Find if the saved tab is still authorized
            const authorizedTab = authorizedTabs.find(tab => tab.tabId === savedTabId);
            if (authorizedTab) {
                return authorizedTab.displayIndex;
            }
        }
        // Default to first authorized tab
        return authorizedTabs.length > 0 ? 0 : 0;
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        const selectedTab = authorizedTabs[newValue];
        if (selectedTab) {
            localStorage.setItem("selectedIECTab", selectedTab.tabId.toString());
        }
        dispatch(handleUpdatePageSlice(false));
    };

    // If no tabs are authorized, show a message
    if (authorizedTabs.length === 0) {
        return (
            <>
                <div style={{ position: 'sticky', top: '0', zIndex: '10' }}>
                    <ToolBar title={'Information Education Communication (IEC)'} className={'rounded-toolbar'} />
                </div>
                <div className="pt-3">
                    <NoPermission />
                </div>
            </>
        );
    }

    return (
        <>
            <ToolBar
                title={'Information Education Communication (IEC)'}
                className={'rounded-toolbar'}
            />

            {/* <div className="tab-section">
                <Tabs
                    TabIndicatorProps={{ style: { background: "rgba(92, 121, 170, 1)" } }}
                    value={value}
                    onChange={handleChange}
                >
                    {tabOptions?.map((tab: any, index: number) => {
                        return (<Tab
                            label={tab?.label}
                            style={{ color: "rgba(92, 121, 170, 1)", fontWeight: "600", textTransform: 'none', minWidth: '50%' }}
                            {...a11yProps(tab?.tabId)}
                            key={index}
                        />)
                    })}
                </Tabs>
            </div> */}

            <CustomTabPanel value={value} index={0}>
                <IECActivities />
            </CustomTabPanel>
        </>
    );
}

export default IEC;